import { CartDateDisplayType, DisplayModeEnum, ItemConditionEnum, LocationConditionEnum } from '@/constants/enum';

export interface IConditionValue {
  data: string;
  variants?: string;
  countryStateName?: string;
  maxInventoryQuantity?: string;
  minInventoryQuantity?: string;
}

export interface IItemCondition {
  id?: number;
  checkoutRuleId?: number;
  type: ItemConditionEnum;
  value: IConditionValue[];
  order?: number;
}

export interface ILocationCondition {
  id?: number;
  checkoutRuleId?: number;
  type: LocationConditionEnum;
  value: IConditionValue[];
  order?: number;
}

export enum RelationCondition {
  AND = 'and',
  OR = 'or',
}

export interface IRule {
  typeRelationOfItemCondition: RelationCondition;
  itemConditions: IItemCondition[];
  locationConditions: ILocationCondition[];
  maxDeliveryDays: number;
  minDeliveryDays: number;
  maxPrepDays: number;
  minPrepDays: number;
  enable?: boolean;
  estimatedText?: string;
  showTextInCart?: boolean;
  cartPageLabelText?: string;
  cartPageDateDisplay?: string;
  cartPageDateDisplayType?: CartDateDisplayType;
  name: string;
  isShowDeliveryMethodName?: boolean;
  styledName?: string;
  soldOutEnabled?: boolean;
  soldOutCustomTextEnabled?: boolean;
  soldOutCustomText?: string;
  privacyPageUrl?: string;
  privacyPageText?: string;
  privacyMore?: string;
  id?: number;
  preOrderDate?: string | null;
  isUsePreOrderDate: boolean;
  isCountInventoryQuantityFromLocations?: boolean;
  displayMode?: DisplayModeEnum;
  startDisplayDate?: string;
  endDisplayDate?: string;
  daySchedules?: IDaySchedule[];
}

export interface IDaySchedule {
  enable: boolean;
  weekday: number;
  startTime: string;
  endTime: string;
}
